<template>
  <div>
    <b-container fluid>
      <ConfiguratorStepTitle :step="configuratorStepNumber" title="PRODUCTOS" />

      <b-row align-h="center" class="mt-3">
        <b-col lg="9" cols="10">
          <b-row align-h="center" class="mb-3">
            <b-col cols="12" lg="6">
              <b-card no-body class="showcase" style='min-height: 0 !important;'>
                <table class="table table-sm table-borderless m-0" style="font-weight: 300;">
                  <tr>
                    <td class="py-0" style="width: 12rem"> {{ rampVehicleTypeLabel }}:</td>
                    <td class="py-0">
                      <span v-if="this.anden.ramp_vehicle_weight">{{ this.anden.ramp_vehicle_weight }} lbs</span>
                      <span v-else class="text-danger"> Pend.</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="py-0">Peso de Carga: </td>
                    <td class="py-0">
                      <span v-if="rampLoadWeightSelected">{{ rampLoadWeightSelected }}</span>
                      <span v-else class="text-danger"> Pend.</span>
                    </td>
                  </tr>
                  <tr>
                    <td class="py-0">Frecuencia de uso:</td>
                    <td class="py-0">
                      <span v-if="frequencyUseSelected">{{ frequencyUseSelected }}</span>
                      <span v-else class="text-danger"> Pend.</span>
                    </td>
                  </tr>
                  <tr class="font-weight-bold text-right">
                    <td class="py-0" colspan="2">
                      <div style="border-top: 1px solid #ccc; padding-top: 0.5rem; margin-top: 0.5rem; margin-bottom: 0px;">
                        <p class="mb-0">Cantidad de libras: {{ totalLbs }} lbs</p>
                      </div>
                    </td>
                  </tr>
                </table>
              </b-card>
              <p v-if="formAlarms['leveler_product']" class="mb-0 mt-2 text-danger text-center fs-14">
                <font-awesome-icon :icon="['far', 'exclamation-circle']" fixed-width />
                {{ formAlarms['leveler_product'] }}
              </p>
            </b-col>
          </b-row>
          <b-row class="d-flex flex-column mb-4">
            <p class="configurator-label">
              <BlankIcon :field="form.leveler_product" />
              Seleccione el tipo de nivelador de borde {{ anden.leveler == 'manual' ? 'manual' : 'automático' }} requerido
            </p>
            <div v-if="anden.leveler == 'manual'" class="product-card-container">
              <ProductCard
                v-for="([group, options], index) in Object.entries(manualLevelersGroup)"
                :key="group + index"
                :active="Object.values(options).map(o => o.value).includes(form.leveler_product)"
                :options="options"
                :image-src="options[0].image"
              >
                <template #body>
                  <b-form-group v-if="options.length > 0" class="mb-0 mt-2">
                    <b-radio-group
                      size="lg"
                      stacked
                      class="ml-1"
                      :options="options"
                      v-model="form.leveler_product"
                      :disabled="options.disabled"
                    />
                  </b-form-group>
                  <p v-else class="text-danger mb-0 fs-14">No hay opciones disponibles de acuerdo a la cantidad de libras</p>
                </template>
              </ProductCard>
            </div>
            <div v-else class="product-card-container">
              <CheckboxCard
                v-for="leveler in automaticLevelersGroup"
                :key="leveler.value"
                :imageSrc="leveler.image"
                :title="leveler.value"
                :checked="form.leveler_product === leveler.value"
                :description="leveler.title"
                :disabled="leveler.disabled"
                @change="handleCheckboxChange(leveler.value)"
              />
            </div>
          </b-row>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapGetters} from 'vuex'
import missingPng from '../../../../../../public/images/original/missing.png'
import MinidockElemaxImage from 'images/andenes/minidock_elemax.webp'
import MinidockOhdImage from 'images/andenes/minidock_ohd.webp'
import MinidockPowerampImage from 'images/andenes/minidock_poweramp.webp'
import MinidockHidraulicoImage from 'images/andenes/minidock_hidraulico.webp'


import ConfiguratorStepTitle from '../ConfiguratorStepTitle'
import BlankIcon from '../BlankIcon'
import ProductCard from './ProductCard'
import CheckboxCard from '../CheckboxCard'

export default {
  name: 'Products',
  components: { ConfiguratorStepTitle, BlankIcon, ProductCard, CheckboxCard },
  props: {
    updateConfigurable: Function
  },
  data () {
    return {
      form: {
        leveler_product: ''
      },
      automaticLevelers: [
          { title: 'Nivelador de borde Hidráulico', value: 'poweramp 20.000 lbs', weight: 20000, disabled: false, image: MinidockHidraulicoImage },
          { title: 'Nivelador de borde Hidráulico', value: 'poweramp 30.000 lbs', weight: 30000, disabled: false, image: MinidockHidraulicoImage }
      ],
      manualLevelers: {
        'elemax': [
          { text: 'Elemax 20.000 lbs', value: 'elemax 20000 lbs', weight: 20000, disabled: false, image: MinidockElemaxImage },
          { text: 'Elemax 30.000 lbs', value: 'elemax 30000 lbs', weight: 30000, disabled: false, image: '' }
        ],
        'ohd': [
          { text: 'OHD 20.000 lbs', value: 'ohd 20000 lbs', weight: 20000, disabled: false, image: MinidockOhdImage },
          { text: 'OHD 30.000 lbs', value: 'ohd 30000 lbs', weight: 30000, disabled: false, image: ''}
        ],
        'poweramp': [
          { text: 'Poweramp 20.000 lbs', value: 'poweramp 20000 lbs', weight: 20000, disabled: false, image: MinidockPowerampImage },
          { text: 'Poweramp 30.000 lbs', value: 'poweramp 30000 lbs', weight: 30000, disabled: false, image: '' }
        ]
      },
      rampVehicleTypeMap: {
        11000: 'Montacargas',
        15000: 'Montacargas',
        145: 'Carretilla manual',
        1765: 'Carretilla automática'
      },
      rampLoadWeightMap: {
        1000: 'Menos de 450 kg (1000 lbs)',
        2205: 'Menos de 1000 kg (2205 lbs)',
        3000: 'Menos de 1360 kg (3000 lbs)',
        5000: 'Menos de 1815 kg (5000 lbs)',
      },
      frequencyUseMap: {
        2: 'Menos de 5 ciclos',
        2.5: 'Más de 5 ciclos',
        3: 'Más de 10 ciclos'
      },
      formAlarms: {}
    }
  },
  mounted () {
    this.setFormData()
  },
  computed: {
    ...mapState({ anden: state => state.configurator.configurable }),
    ...mapGetters(['configuratorStepNumber', 'getStepAlarms']),
    missingImg () {
      return missingPng
    },
    rampVehicleTypeLabel () {
      let label = 'Peso'
      if (!this.anden) return label
      return label + ' ' + this.rampVehicleTypeMap[this.anden.ramp_vehicle_weight]
    },
    rampLoadWeightSelected () {
      if (!this.anden) return ''
      return this.rampLoadWeightMap[this.anden.ramp_load_weight] || ''
    },
    frequencyUseSelected () {
      if (!this.anden) return ''
      return this.frequencyUseMap[this.anden.frequency_use] || ''
    },
    totalLbs () {
      return this.totalLbsCalc()
    },
    manualLevelersGroup () {
      const levelerGroup = {}
      Object.entries( this.manualLevelers).forEach(([key, value]) => {
        const values = value.map(el => {
          const option = el
          if (this.totalLbs === 0 || this.totalLbs > el.weight) {
            option.disabled = true
          }
          return option
        })
        levelerGroup[key] = values
      })
      return levelerGroup
    },
    automaticLevelersGroup () {
      return this.automaticLevelers.map(el => {
        let option = el
        if (this.totalLbs === 0 || this.totalLbs > el.weight) {
          option.disabled = true
        }
        return option
      })
    }
  },
  methods: {
    async update () {
      if (!this.formHasChanged()) return true

      const result = await this.updateConfigurable(this.form)
      return result
    },
    setFormData () {
      if (!this.anden) return
      this.form.leveler_product = this.anden.leveler_product
      this.formAlarms = this.getStepAlarms('products')
    },
    totalLbsCalc () {
      if (!this.anden) return 0
      const { ramp_vehicle_weight, ramp_load_weight, frequency_use } = this.anden
      const total = (ramp_vehicle_weight + ramp_load_weight) * frequency_use
      return total
    },
    formHasChanged () {
      return Object.entries(this.form).some(([key, value]) => value !== this.anden[key])
    },
    handleCheckboxChange (value) {
      this.form.leveler_product = value
    }
  }
}
</script>

<style scoped>
.product-card-container {
  display: flex;
  margin-top: 2rem;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 2em;
}
</style>
